import React from 'react'
import { useTranslation } from 'react-i18next';
import BarChartProjectReport from '../../../../../Projects/ProjectsReport/components/BarChartProjectReport/BarChartProjectReport';

const LastFiveYears = ({ chartData }) => {
    const { t } = useTranslation();

    return (
        <>
            <h3 className="cell-title">
                {t('extended_report.disbursements_and_projections')}
            </h3>
            <div className='grid-disbursements mt-5'>
                <div className='disbursment-for-year'>
                    <p>{t('extended_report.disbursement_comparison_info')}</p>
                    <p className='mt-2'>{t('extended_report.convergence_source_note')}</p>
                </div>
                <div className='size-height-bar '>
                    <div className='inidicators-bar-chart'>

                        <div className='projection-and-amount-indicator'>
                            <div className='amount-disbursed-icon'></div>
                            <p>{t('one_pager_report.amount_disbursed')}</p>
                        </div>

                        <div className='projection-and-amount-indicator'>
                            <div className='projection-icon'></div>
                            <p>{t('one_pager_report.original_projection')}</p>
                        </div>

                        <div className='projection-and-amount-indicator'>
                            <div className='current-projection-icon'></div>
                            <p>{t('extended_report.current_projection')}</p>
                        </div>
                    </div>
                    <BarChartProjectReport chart={[...chartData].sort((a, b) => a.year - b.year)} />
                </div>
            </div>
        </>
    )
}

export default LastFiveYears